import {
  JobsContainer,
  SearchContainer,
  PageBtnContainer,
} from '../../components';

const AllJobs = () => {
  return (
    <>
      <SearchContainer />
      <JobsContainer />
      <PageBtnContainer />
    </>
  );
};

export default AllJobs;
